

import { ETaskStatus, ITask } from '../../../data_models/task'
import { EProjectStatus, IProject } from '../../../data_models/project'
import { IFreelancer } from '../../../data_models/freelancer'
import { FilledButton, FlatButton, OutlinedButton, TextButton } from '../../common/Button';
import { MdOutlineAttachMoney } from 'react-icons/md';
import { IEmployer } from '../../../data_models/employer';
import { useEffect, useState } from 'react';
import { IoCloudDownloadOutline, IoPencil, IoShieldHalfOutline, IoTrailSignOutline, IoTrashOutline, IoConstructOutline, IoTimeOutline, IoPeopleOutline, IoShieldCheckmarkOutline, IoShieldOutline, IoShieldCheckmark, IoConstruct, IoRefreshOutline } from 'react-icons/io5';
import IconButton from '../../common/IconButton';
import TextInputField from '../../common/TextInputField';
import { IoMdClose } from 'react-icons/io';
import { IoMdCheckmark } from 'react-icons/io';
import useProjects from '../../../hooks/useProjects';
import { ConfirmDeleteProjectDraftLightbox } from '../../lightboxes/projects/ConfirmDeleteProjectDraftLightbox';
import CreateNewRoadmapLightbox from '../../lightboxes/projects/CreateNewRoadmapLightbox';
import useDisplayNotifications from '../../../hooks/useDisplayNotifications';
import { ProjectStatusBatch } from '../../common/StatusBatch';
import RequestRoadmapVerificationLightbox from '../../lightboxes/projects/RequestRoadmapVerificationLightbox';
import useRouting, { EProjectDetailsNav } from '../../../hooks/useRouting';
import StartProjectSelfManagedLightbox from '../../lightboxes/projects/StartProjectSelfManagedLightbox';
import Tooltip from '../../common/Tooltip';
import VerifyRoadmapLightbox from '../../lightboxes/projects/VerifyRoadmapLightbox';
import VerificationPmAgreeToContinueLightbox from '../../lightboxes/projects/VerificationPmAgreeToContinueLightbox';
import StartProjectWithPmLightbox from '../../lightboxes/projects/StartProjectWithPmLightbox';
import AvatarWithDetails from '../../common/AvatarWithDetails';
import { EArielleProcessingType } from '../../../data_models/aiModels/enums';
import useArielle from '../../../hooks/useArielle';



export const ProjectDetailsHeader: React.FC<{
    project: IProject,
    tasks: ITask[],
    roadmapVerificationPm: IFreelancer | null,
    projectManager: IFreelancer | null,
    team: IFreelancer[],
    employer: IEmployer | null,
    isPm: boolean,
    isRoadmapVerificationPm: boolean,
    isEmployer: boolean,
    isFreelancer: boolean,
    isOutsideFreelancer: boolean,
    isOutsideEmployer: boolean,

    navigation: any[],
    setNavigation: (navigation: any[]) => void,
    setProject: (project: IProject) => void,
    setTasks: (tasks: ITask[]) => void,
    refreshing: boolean,
    setRefreshing: (refreshing: boolean) => void,

}> = ({ project, tasks, roadmapVerificationPm, projectManager, team, employer, isPm,
    isRoadmapVerificationPm, isEmployer, isFreelancer, isOutsideFreelancer,
    isOutsideEmployer, navigation, setNavigation, setProject, setTasks, refreshing, setRefreshing }) => {

        const [canBuyCredits, setCanBuyCredits] = useState(false);
        const [canEdit, setCanEdit] = useState(false);
        const [canDelete, setCanDelete] = useState(false);
        const [canCreateRoadmap, setCanCreateRoadmap] = useState(false);
        const [canDownloadRoadmap, setCanDownloadRoadmap] = useState(false);

        const [canRequestRoadmapVerification, setCanRequestRoadmapVerification] = useState(false);
        const [canStartProjectSelfManaged, setCanStartProjectSelfManaged] = useState(false);
        const [canStartProjectWithPm, setCanStartProjectWithPm] = useState(false);
        const [canVerifyRoadmap, setCanVerifyRoadmap] = useState(false);

        const [editTitle, setEditTitle] = useState(false);
        const [newTitle, setNewTitle] = useState(project.title);
        const [isLoading, setIsLoading] = useState(false);

        const [isLoadingDownloadRoadmap, setIsLoadingDownloadRoadmap] = useState(false);

        const [showConfirmDeleteProjectDraftLightbox, setShowConfirmDeleteProjectDraftLightbox] = useState(false);
        const [showCreateNewRoadmapLightbox, setShowCreateNewRoadmapLightbox] = useState(false);
        const [showRequestRoadmapVerificationLightbox, setShowRequestRoadmapVerificationLightbox] = useState(false);
        const [showAskToContinueAsPmLightbox, setShowAskToContinueAsPmLightbox] = useState(false);
        const [showStartProjectSelfManagedLightbox, setShowStartProjectSelfManagedLightbox] = useState(false);
        const [showStartProjectWithPmLightbox, setShowStartProjectWithPmLightbox] = useState(false);
        const [showVerifyRoadmapLightbox, setShowVerifyRoadmapLightbox] = useState(false);

        const [showActionMenu, setShowActionMenu] = useState(false);

        const { updateProjectDetails,
            createAndDownloadProjectRoadmapPdf } = useProjects();
        const { addErrorNotification } = useDisplayNotifications();
        const { goToPricing, goToProjectDetails } = useRouting();
        const { isProcessing } = useArielle();



        useEffect(() => {

            // Can buy credits
            if (isEmployer) {
                setCanBuyCredits(true);
            } else {
                setCanBuyCredits(false);
            }

            // Can edit
            if ((isPm || isEmployer || isRoadmapVerificationPm) && (project.status || 0) < EProjectStatus.IN_PROGRESS) {
                setCanEdit(true);
            } else {
                setCanEdit(false);
            }

            // Can delete
            if (isEmployer
                && (project.status || 0) < EProjectStatus.IN_PROGRESS
                && !project._waitingForRoadmapVerification
                && !project.currentProjectManager
                && !project.currentRoadmapVerificationPm
                && !tasks.some(task => task.currentStatus && task.currentStatus >= ETaskStatus.IN_PROGRESS)
            ) {
                setCanDelete(true);
            } else {
                setCanDelete(false);
            }

            // Can download roadmap
            if ((isEmployer || isPm || isRoadmapVerificationPm) || tasks.length > 0) {
                setCanDownloadRoadmap(true);
            } else {
                setCanDownloadRoadmap(false);
            }

            // Can create roadmap
            if (isEmployer && (project.status || 0) === EProjectStatus.DRAFT) {
                setCanCreateRoadmap(true);
            } else {
                setCanCreateRoadmap(false);
            }

            // Can verify roadmap
            if (isEmployer && project
                && project?.status !== undefined
                && !project._waitingForRoadmapVerification
                && project?.status < EProjectStatus.COMPLETED
                && project.status !== EProjectStatus.IN_PROGRESS_REASSIGN_PM
                && project.status !== EProjectStatus.WAITING_FOR_PM
                && !project.currentRoadmapVerificationPm
                && !project.currentProjectManager
                && tasks.length > 0
            ) {
                setCanRequestRoadmapVerification(true);
            } else {
                setCanRequestRoadmapVerification(false);
            }

            // Can start project self managed
            if (isEmployer && project.status === EProjectStatus.DRAFT && tasks.length > 0 && !project._waitingForRoadmapVerification) {
                setCanStartProjectSelfManaged(true);
            } else {
                setCanStartProjectSelfManaged(false);
            }

            // Can start project with pm
            if (isEmployer && project.status === EProjectStatus.DRAFT && tasks.length > 0 && project._roadmapVerifiedAt) {
                setCanStartProjectWithPm(true);
            } else {
                setCanStartProjectWithPm(false);
            }


            // can verify roadmap
            if (isRoadmapVerificationPm && project._waitingForRoadmapVerification) {
                setCanVerifyRoadmap(true);
            } else {
                setCanVerifyRoadmap(false);
            }
        }, [project, tasks, isPm, isRoadmapVerificationPm, isEmployer, isFreelancer, isOutsideFreelancer, isOutsideEmployer]);


        const onDelete = () => {
            setShowConfirmDeleteProjectDraftLightbox(true);
        }

        const onCreateRoadmap = () => {
            setShowCreateNewRoadmapLightbox(true);
        }

        const onEditTitle = async () => {
            if (!newTitle) {
                setEditTitle(false);
                return;
            }

            const updateObj: IProject = {
                ...project,
                title: newTitle
            };

            setIsLoading(true);
            const updatedProject = await updateProjectDetails(updateObj);
            if (updatedProject) {
                setProject(updatedProject);
                setEditTitle(false);
            }
            setIsLoading(false);
        }

        const onDownloadRoadmapPdf = async () => {

            if (tasks.length === 0) {
                addErrorNotification('To download a full roadmap, you’ll need to define some tasks first. You can add them yourself or let Arielle, our AI assistant producer, help you build it in no time!',
                    'Download Failed'
                );
            } else {
                setIsLoadingDownloadRoadmap(true);
                await createAndDownloadProjectRoadmapPdf(project._id!);
                setIsLoadingDownloadRoadmap(false);
            }
        }

        const onStartProjectSelfManaged = () => {
            setShowStartProjectSelfManagedLightbox(true);
        }

        const onStartProjectWithPm = () => {
            setShowStartProjectWithPmLightbox(true);
        }

        const onRequestRoadmapVerification = () => {
            setShowRequestRoadmapVerificationLightbox(true);
        }

        const onVerifyRoadmap = () => {
            setShowVerifyRoadmapLightbox(true);
        }

        const onGoToTeam = () => {
            const newNavigation = navigation.map(item => ({
                ...item,
                current: item.nav.toLowerCase() === (EProjectDetailsNav.TEAM).toLowerCase()
            }));

            const currParams = new URLSearchParams(window.location.search);
            currParams.set('nav', EProjectDetailsNav.TEAM);
            window.history.pushState({}, '', window.location.pathname + '?' + currParams.toString());
            setNavigation(newNavigation);
        }


        const onGoToRoadmap = () => {
            const newNavigation = navigation.map(item => ({
                ...item,
                current: item.nav.toLowerCase() === (EProjectDetailsNav.ROADMAP).toLowerCase()
            }));

            const currParams = new URLSearchParams(window.location.search);
            currParams.set('nav', EProjectDetailsNav.ROADMAP);
            window.history.pushState({}, '', window.location.pathname + '?' + currParams.toString());
            setNavigation(newNavigation);
        }


        return (
            <div>
                <div className="w-full lg:flex lg:items-start lg:justify-between">
                    <div className="min-w-0 flex-1">
                        <div className='flex flex-row items-center gap-2'>
                            {editTitle
                                ? <TextInputField
                                    value={newTitle || ''}
                                    onChange={(e) => setNewTitle(e.target.value)}
                                />
                                : <div className='flex flex-row items-center gap-2'>
                                    <IconButton
                                        icon={<IoRefreshOutline />}
                                        onClick={() => setRefreshing(true)}
                                        theme='black'
                                        isLoading={refreshing}
                                    />
                                    <h2 className="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                                        {project.title}
                                    </h2>
                                </div>}

                            {canEdit && !editTitle && <IconButton
                                icon={<IoPencil />}
                                onClick={() => setEditTitle(true)}
                                theme='primary'
                                disabled={project._roadmapVerifiedBy !== undefined && project._roadmapVerifiedBy !== null}
                            />}
                            {canEdit && editTitle && (
                                <div className="flex gap-2">
                                    <IconButton
                                        icon={<IoMdCheckmark />}
                                        onClick={onEditTitle}
                                        theme='primary'
                                        isLoading={isLoading}
                                    />
                                    <IconButton
                                        icon={<IoMdClose />}
                                        onClick={() => setEditTitle(false)}
                                        theme='danger'
                                    />
                                </div>
                            )}

                        </div>

                        <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap items-center sm:space-x-6">
                            <div className='mt-2'>
                                <ProjectStatusBatch status={project.status} variant='flat' />
                            </div>
                            <div className="mt-2 flex items-center text-sm cursor-pointer hover:underline"
                                onClick={onGoToRoadmap}>
                                {
                                    !project._roadmapVerifiedAt && project.currentRoadmapVerificationPm ? (
                                        <Tooltip
                                            text='Roadmap is under review. Be responsive—verification is coming shortly.'>
                                            <div className='flex items-center text-green-500'>
                                                <IoShieldCheckmarkOutline className='mr-1.5 size-5 shrink-0' />
                                                <span>Roadmap Review in Progress</span>
                                            </div>
                                        </Tooltip>
                                    ) : project._waitingForRoadmapVerification && !project.currentRoadmapVerificationPm ? (
                                        <Tooltip text='We’re on it! Your expert will be assigned shortly.'>
                                            <div className='flex items-center text-lime-500'>
                                                <IoShieldOutline className='mr-1.5 size-5 shrink-0 ' />
                                                <span>Expert Assignment in Progress</span>
                                            </div>
                                        </Tooltip>
                                    ) : !project._waitingForRoadmapVerification && project._roadmapVerifiedAt ? (
                                        <Tooltip text='Roadmap verified—you’re ready to move forward with confidence.'>
                                            <div className='flex items-center text-secondary-500'>
                                                <IoShieldCheckmark className='mr-1.5 size-5 shrink-0' />
                                                <span>Roadmap Verified</span>
                                            </div>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip text='Roadmap not yet verified. You can proceed on your own or request expert review.'>
                                            <div className='flex items-center text-gray-500'>
                                                <IoShieldOutline className='mr-1.5 size-5 shrink-0' />
                                                <span>Roadmap Not Verified</span>
                                            </div>
                                        </Tooltip>
                                    )
                                }
                            </div>

                            {project.status === EProjectStatus.IN_PROGRESS && <div className="mt-2 flex items-center text-sm text-gray-500 ">
                                {project.ownerManaged && <IoConstructOutline className='mr-1.5 size-5 shrink-0 text-gray-400' />}
                                {project.ownerManaged && <Tooltip text='You’re managing this project yourself. If you feel stuck, you can hire a project manager.'><span>Self Managed</span></Tooltip>}
                                {!project.ownerManaged && <IoConstruct className='mr-1.5 size-5 shrink-0 text-gray-400' />}
                                {!project.ownerManaged && <Tooltip text='You’ve hired a project manager to handle this project.'><span>PM Managed</span></Tooltip>}
                            </div>}

                            <div className="mt-2 flex items-center text-sm text-gray-500 hover:underline cursor-pointer"
                                onClick={onGoToTeam}>
                                <IoPeopleOutline className='mr-1.5 size-5 shrink-0 text-gray-400' />
                                {team.length} Team members
                            </div>


                            <Tooltip text="Total effort needed, calculated from your current roadmap.">
                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                    <IoTimeOutline className='mr-1.5 size-5 shrink-0 text-gray-400' />
                                    {project.totalCredits} {isEmployer ? 'Hrs' : 'Credits'}
                                </div>
                            </Tooltip>
                        </div>

                    </div>

                    {/* Action Buttons */}
                    <div className="mt-5 flex lg:mt-0 lg:ml-4">
                        <span className="flex flex-wrap gap-4 items-center w-full">
                            {canDelete && (
                                <Tooltip text="Delete this project.">
                                    <TextButton
                                        onClick={onDelete}
                                        icon={<IoTrashOutline />}
                                        theme='danger'
                                    >Delete</TextButton>
                                </Tooltip>
                            )}
                            {canDownloadRoadmap && (
                                <Tooltip text={tasks.length === 0 ? 'To download a full roadmap, you’ll need to build it first.' : 'Download roadmap as a PDF file.'}>
                                    <OutlinedButton
                                        onClick={onDownloadRoadmapPdf}
                                        icon={<IoCloudDownloadOutline />}
                                        isLoading={isLoadingDownloadRoadmap}
                                        theme='primary'
                                        disabled={tasks.length === 0}
                                    >Download</OutlinedButton>
                                </Tooltip>
                            )}
                            {canCreateRoadmap && (
                                <Tooltip text={project._roadmapVerifiedAt
                                    ? 'This button is disabled because your current roadmap is already verified. Starting fresh would replace the verified version.'
                                    : (project._waitingForRoadmapVerification && !project.currentRoadmapVerificationPm)
                                        ? 'Your roadmap is under review. Creating a new one would disturb the process.'
                                        : 'Arielle, our AI assistant producer, will build a new roadmap in no time for you!'}>
                                    <FilledButton
                                        onClick={onCreateRoadmap}
                                        icon={<IoTrailSignOutline />}
                                        theme='primary'
                                        isLoading={isProcessing.has(EArielleProcessingType.CREATE_PROJECT_ROADMAP)}
                                        disabled={!!project._roadmapVerifiedAt || (project._waitingForRoadmapVerification && !project.currentRoadmapVerificationPm)}
                                    >Build New Roadmap</FilledButton>
                                </Tooltip>
                            )}
                            {canVerifyRoadmap && (
                                <Tooltip text="Verify the roadmap to give your client more confidence.">
                                    <FilledButton
                                        onClick={onVerifyRoadmap}
                                        icon={<IoShieldCheckmarkOutline />}
                                        theme='primary'
                                    >Verify Roadmap</FilledButton>
                                </Tooltip>
                            )}


                        </span>
                    </div>

                </div>

                {/* Users */}
                <div className="mt-4 mb-8 flex flex-row space-x-6">
                    {employer && <AvatarWithDetails user={employer} title="Client" chatNow={isPm || isRoadmapVerificationPm || (isFreelancer && project.ownerManaged)} />}
                    {roadmapVerificationPm &&
                        project.currentRoadmapVerificationPm !== project.currentProjectManager &&
                        <AvatarWithDetails user={roadmapVerificationPm} title="Roadmap Expert" chatNow={isEmployer || isPm} />}
                    {projectManager && <AvatarWithDetails user={projectManager} title="Project Manager" chatNow={isEmployer || (isRoadmapVerificationPm && project.currentRoadmapVerificationPm !== project.currentProjectManager) || isFreelancer} />}
                </div>
                {showConfirmDeleteProjectDraftLightbox && (
                    <ConfirmDeleteProjectDraftLightbox
                        project={project}
                        onClose={() => setShowConfirmDeleteProjectDraftLightbox(false)}
                    />
                )}
                {showCreateNewRoadmapLightbox && (
                    <CreateNewRoadmapLightbox
                        projectId={project._id || ''}
                        onClose={() => setShowCreateNewRoadmapLightbox(false)}
                        onReplaceTasks={setTasks}
                    />
                )}
                {showRequestRoadmapVerificationLightbox &&
                    <RequestRoadmapVerificationLightbox
                        onClose={() => { setShowRequestRoadmapVerificationLightbox(false) }}
                        projectId={project._id!}
                        onUpdateProject={setProject}
                        onUpdateTasks={setTasks}
                    />}
                {showStartProjectSelfManagedLightbox && (
                    <StartProjectSelfManagedLightbox
                        project={project}
                        onClose={() => setShowStartProjectSelfManagedLightbox(false)}
                        onProjectUpdate={setProject}
                        onTasksUpdate={setTasks}
                    />
                )}
                {showStartProjectWithPmLightbox && (
                    <StartProjectWithPmLightbox
                        projectId={project._id!}
                        onClose={() => setShowStartProjectWithPmLightbox(false)}
                        onProjectUpdate={setProject}
                        onTasksUpdate={setTasks}
                    />
                )}
                {showVerifyRoadmapLightbox && (
                    <VerifyRoadmapLightbox
                        projectId={project._id!}
                        onClose={() => setShowVerifyRoadmapLightbox(false)}
                        onUpdateProject={setProject}
                        afterConfirmAction={() => {
                            setShowAskToContinueAsPmLightbox(true);
                        }}
                    />
                )}
                {showAskToContinueAsPmLightbox && (
                    <VerificationPmAgreeToContinueLightbox
                        onClose={() => setShowAskToContinueAsPmLightbox(false)}
                        projectId={project._id!}
                        onUpdateProject={setProject}
                    />
                )}
            </div>
        )
    }